import type { SVGProps } from "react";
export function TriangleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m6.31672 3.11821-4.45769 7.34709c-.80868 1.3328.15089 3.0374 1.70989 3.0374h8.91538c1.559 0 2.5186-1.7046 1.7099-3.0374l-4.4577-7.3471c-.77869-1.28341-2.6411-1.28341-3.41978.00001z"
        fill="currentColor"
      />
    </svg>
  );
}
